<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a class="navbar-brand" href="#">Asotrauma</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav" v-for="link in links" v-bind:key="link.id">
                    <li class="nav-item active">
                        <a class="nav-link" :href="link.link">{{link.name}} <span class="sr-only">(current)</span></a>
                    </li>
                </ul>
                <ul class="navbar-nav">
                    <li class="nav-item active btn-logout">
                        <a class="nav-link" href="#" v-on:click.prevent="logout">Cerrar sesión<span class="sr-only">(current)</span></a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>
<script>
export default {
    name: 'navbar',
    props: {
        links: {
            type: Array,
            required: true,
        }
    },
    data(){
        return {
            
        }
    },
    methods: {
        logout: function(){
            this.$router.push('/');
            localStorage.clear();
        }
    }
}
</script>



